export enum ChoosePostOfficeTextEnum {
    ChoosePostOffice_Title = 'choose_post_office_title',
    CPO_PostOfficeList_Title = 'choose_post_office_list_title',
    CPO_PostOfficeItem_OpenTime='choose_post_office_list_open_time'
}